<template>
  <div class="page-wrap">
    <div class="play-manage">
      <div class="header">
        <div class="header-title">玩法管理</div>
        <div class="header-filter">
          <el-input placeholder="搜索玩法名称" suffix-icon="el-icon-search" v-model="playName" @change="searchData"> </el-input>
          <el-button class="add-btn" type="primary" @click="addPlayMethod">新增玩法</el-button>
        </div>
      </div>
      <el-table
        :data="list"
        style="flex: 1"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.1)"
        ref="table"
      >
        <el-table-column label="序号" prop="index" width="200"></el-table-column>
        <el-table-column label="玩法名称" prop="playName"></el-table-column>
        <el-table-column label="产品投放负责人" prop="deliveryLeader">
          <template slot-scope="scope">
            {{ scope.row.deliveryLeader || "--" }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="text" @click="handleEdit(scope.row)">编辑 </el-button>
            <el-button class="delete-btn" type="text" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <self-pagination
      class="footer-page"
      :total="pageData.total"
      :pageSize="pageData.size"
      :currentPage="pageData.page"
      @getCurrentPage="changePage"
      @handleSizeChange="handleSizeChange"
    ></self-pagination>
    <el-dialog :visible.sync="centerDialogVisible" width="448px" :close-on-click-modal="false" @open="openDialog">
      <span slot="title" class="dialog-title">{{ modalType === "add" ? "添加玩法" : "编辑玩法" }}</span>
      <div>
        <el-form label-width="130px" :model="formData" :rules="rules" ref="tableRef">
          <el-form-item prop="playName" label="玩法名称：">
            <el-input v-model="formData.playName" placeholder="请输入玩法名称"></el-input>
          </el-form-item>
          <el-form-item label="产品投放负责人：" prop="deliveryLeader" class="member">
            <el-select v-model="formData.deliveryLeader" placeholder="请选择产品投放负责人" filterable allow-create>
              <el-option v-for="(item, index) in principalNameList" :key="index" :label="item" :value="item"> </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取 消</el-button>
        <el-button type="primary" @click="handleConfirm" :loading="loading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getPlayInfoList, updatePlayInfo, deletePlayInfo, addPlayInfo, geteaderList } from "@/api/rolepower.js";
export default {
  data() {
    return {
      list: [],
      principalNameList: [],
      playName: "",
      centerDialogVisible: false,
      editModalVisible: false,
      loading: false,
      formData: {
        playName: "",
        deliveryLeader: "",
      },
      pageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      rules: {
        playName: [
          {
            required: true,
            message: "请输入玩法名称",
            trigger: ["blur", "change"],
          },
        ],
        deliveryLeader: [
          {
            required: true,
            message: "请选择产品投放负责人",
            trigger: ["blur", "change"],
          },
        ],
      },
      modalType: "",
    };
  },
  mounted() {
    this.searchData(true);
  },
  methods: {
    searchData(resetpage) {
      if (resetpage) {
        this.pageData.page = 1;
      }
      let parmas = {
        pageNum: this.pageData.page + "",
        pageSize: this.pageData.size + "",
        playName: this.playName,
      };
      getPlayInfoList(parmas).then((res) => {
        if (res.code === "0000") {
          this.list = res.data.list.map((item, index) => {
            item.index = (res.data.pageNum - 1) * res.data.pageSize + index + 1;
            return item;
          });
          this.pageData.total = res.data.total;
          this.pageData.page = res.data.pageNum;
        }
      });
    },
    changePage(page) {
      this.pageData.page = page;
      this.searchData(false);
    },
    handleSizeChange(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.searchData(false);
    },
    addPlayMethod() {
      this.modalType = "add";
      this.centerDialogVisible = true;
      this.formData.playName = "";
      this.formData.deliveryLeader = "";
    },
    handleCancel() {
      this.centerDialogVisible = false;
    },
    handleConfirm() {
      this.$refs.tableRef.validate((valid) => {
        if (valid) {
          let copyData = JSON.parse(JSON.stringify(this.formData));
          this.loading = true;
          if (this.modalType === "add") {
            addPlayInfo(copyData).then((res) => {
              this.loading = false;
              if (res.code === "0000") {
                this.$message({
                  message: "玩法信息添加成功",
                  type: "success",
                });
                this.searchData(false);
                this.centerDialogVisible = false;
              }
            });
          } else {
            updatePlayInfo(copyData).then((res) => {
              this.loading = false;
              if (res.code === "0000") {
                this.$message({
                  message: "玩法信息编辑成功",
                  type: "success",
                });
                this.searchData(false);
                this.centerDialogVisible = false;
              }
            });
          }
        }
      });
    },
    handleDelete(data) {
      this.$confirm("此操作将永久删除该玩法, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deletePlayInfo({ id: data.id }).then((res) => {
            if (res.code === "0000") {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.searchData(false);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleEdit(data) {
      this.modalType = "edit";
      const { id, playName } = data;
      this.formData = {
        playName,
        id,
      };
      this.centerDialogVisible = true;
    },
    openDialog() {
      //投放负责人
      geteaderList().then((res) => {
        this.principalNameList = res.data;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.page-wrap {
  // padding: 16px 16px 0px 16px;
  box-sizing: border-box;
  height: calc(100vh - 50px);
  overflow: hidden;
}
.play-manage {
  margin: 16px;
  box-sizing: border-box;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  padding: 16px 24px;
  height: calc(100% - 80px);
  overflow: auto;
  .header {
    display: flex;
    margin-bottom: 16px;
    .header-title {
      color: rgba(0, 0, 0, 0.85);
      font-weight: bold;
      font-size: 15px;
      flex: 1;
      margin-top: 6px;
    }
    .header-filter {
      display: flex;
      .add-btn {
        margin-left: 14px;
      }
    }
  }
}
.popover {
  .edit-cancel {
    margin: 10px 16px;
    cursor: pointer;
  }
  .edit-save {
    margin-top: 10px;
    cursor: pointer;
    color: rgb(24, 144, 255);
  }
}
.dialog-title {
  color: rgba(0, 0, 0, 0.85);
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
}
.delete-btn {
  margin-left: 16px;
}
.footer-page {
  padding: 0px 0px 16px 0px;
}
.member {
  /deep/ .el-select {
    width: 100%;
  }
}
/deep/ .el-dialog {
  border-radius: 4px;
}
/deep/ .el-dialog__footer {
  padding: 5px 34px 24px 34px;
}
</style>
